/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 * Migrated from: lego/page/reports/common/BlueInfoBox.jsx
 */

import React from 'react'
import DOMPurify from 'dompurify'
import { useServiceContext } from '../../root'

interface BlueInfoBoxProps {
  message?: string
}

/**
 * CSS class: report-willbe-generated-info
 */
export const BlueInfoBox: React.FC<BlueInfoBoxProps> = ({ message }) => {
  const context = useServiceContext()
  const translate = context.service.filter.translate

  return (
    <div
      className="report-willbe-generated-info"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(translate(message ? message : 'REPORTS_EXPORT_BLUE_INFO_BOX'))
      }}
    />
  )
}
